import React from 'react'
import './Intro.css'
import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';
import Vector1 from '../../img/Vector1.png';
import Vector2 from '../../img/Vector2.png';
import boy from '../../img/boy.png';
import thumbup from '../../img/thumbup.png';
import Crown from '../../img/crown.png';
import glassesimoji from '../../img/glassesimoji.png';
import FloatingDiv from '../FloatingDiv/FloatingDiv';
import {themeContext} from '../../Context'
import { useContext } from 'react';
// import {AnimatePresence,motion} from 'framer-motion/dist/framer-motion';
import {motion} from 'framer-motion'
import {Link} from 'react-scroll'


 const Intro = () => {
    const transition = {duration : 2, type: 'spring'}
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="intro">
        <div className="i-left">
        <div className="i-name">
            <span style={{color: darkMode? 'white':''}}>Hey! I Am</span>
            <span>Ratikant Patil</span>
            <span>I Am Fresher, Having Good Knowledge Of
                 Full-Stack Web Development, Python Programming
                 & Angular, ReactJS FramWorks .
            </span>
        </div>
        <Link spy={true} to='Contact' smooth={true} activeClass='activeClass'>
        <button className="button i-button" id='butt'>Hire me</button>
        </Link>
        <div className="i-icons">
            <a href='https://github.com/RatikantPatil01'>
                <img src={Github} alt="" />
            </a>

            <a href="https://www.linkedin.com/in/ratikant-patil-9b5521218/">
                <img src={LinkedIn} alt="" />
            </a>
            
            <a href="https://www.instagram.com/patil_ratikant_01/?next=%2F">
                <img src={Instagram} alt="" />
            </a>
            
        </div>

        </div>
        <div className="i-right">
            
            <img src={Vector1} alt="" id='pic'/>
            <img src={Vector2} alt="" id='pic' />
            <img src={boy} alt="" id='pic2'/>
            <motion.img 
            initial={{left: '-36%'}}
            whileInView= {{left: '-24%'}}
            transition={transition}
            src={glassesimoji} alt=""
            id='glapic' 
            />
            <motion.div
            initial={{top: '-4%', left:'74%'}}
            whileInView={{left: '68%'}}
            transition={transition} 
            style={{top: '-4%', left: '68%',zIndex:'0',}}
            className='floating-div'>
                <FloatingDiv image={Crown} txt1='Python' txt2='Programming'/>
            </motion.div>

            <motion.div
            initial={{left: '9rem', top:'14rem'}}
            whileInView={{left: '0rem'}}
            transition={transition}
            style={{top:'15rem', left: '0rem',}}
            className='floating-div'>
                <FloatingDiv image={thumbup} txt1='Web' txt2='Developer'/>
            </motion.div>
            {/* blur divs */}
            <div className='blur' style={{background: "rgn(238 210 255"}}></div>
            <div className='blur'
            style={{
                background: '#C1F5FF',
                top:'17rem',
                width: '21rem',
                height: '11rem',
                left: '-9rem'
            }}
            ></div>
        </div>
    </div>
  )
}

export default Intro
